module.exports = __webpack_public_path__ + "2bea4394aa22aff87428d4eb7991ee5b.png";